import React from 'react';
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { AnimatePresence } from 'framer-motion';
import Questionaire from "./pages/questionaire";
import Resources from "./pages/resources";
import NavBar from "./components/navbar/Navbar";
import './App.css';

function App() {
  return (
    <div className="app-layout">
      <Router>
        <NavBar />
        <div className="app-content">
          <AnimatePresence mode="wait">
            <Routes>
              <Route exact path="/" element={<Questionaire />} />
              <Route path="/resources" element={<Resources />} />
            </Routes>
          </AnimatePresence>
        </div>
      </Router>
    </div>
  );
}

export default App;
